import styled from '@emotion/styled';
import { Typography } from '@kc-console/common-ui';
import { IcArrowEnterRegular, IcClockRegular } from '@kep/kcds-icons';

import { useSearchPopover } from './SearchPopoverProvider';

import type { KeyboardEvent } from 'react';

interface Props {
  name: string;
  focused?: boolean;
  index?: number;
}

const RecentSearchKeywordMenuItem = ({ name, index, focused }: Props) => {
  const { setInputValue, setFocusedIndex } = useSearchPopover();

  const handleClick = () => {
    return setInputValue(name);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLLIElement>) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  // onMouseEnter 대신 onMouseMove 사용: 키보드로 스크롤 시 마우스 커서 위치에 새 요소가 들어와도 실제로 마우스가 움직이지 않았다면 포커스 변경을 방지
  const handleMouseMove = () => {
    if (index !== undefined) {
      setFocusedIndex(index);
    }
  };

  return (
    <MenuItemWrapper
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      tabIndex={-1}
      onKeyDown={handleKeyDown}
      data-search-item-index={index}
      data-focused={focused}
    >
      <MenuItemContentContainer>
        <MenuItemContentLeftContainer>
          <IcClockRegular fontSize={16} />
          <Typography variant={'label/regular/md'}>{name}</Typography>
        </MenuItemContentLeftContainer>
        <div id="enter-icon">
          <IcArrowEnterRegular />
        </div>
      </MenuItemContentContainer>
    </MenuItemWrapper>
  );
};

const MenuItemWrapper = styled.li`
  height: 42px;
  padding: 10.5px 16px;
  cursor: pointer;
  list-style: none;

  #enter-icon {
    display: none;
  }

  &:active {
    background-color: #f6f7f9;
  }

  &:active,
  &[data-focused='true'] {
    #enter-icon {
      display: block;
    }
  }

  &[data-focused='true'] {
    background-color: #f9fafb;
  }

  &:focus-visible {
    background-color: transparent;
    outline: 2px solid #000;
    outline-offset: -2px;
  }
`;

const MenuItemContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MenuItemContentLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default RecentSearchKeywordMenuItem;
